import $ = require("jquery");
import _ = require("underscore");
import MapServer = require("arcgis/services/mapserver");
import ArcgisServices = require("../../models/arcgis-services");
import Utils = require("../../utils");
import Portal = require("portal-gis");
import AgsLayers = require("./ags-layers");

class AgsDirectory {

    static about = `
Gets multiple MapServer services from a single directory
    `;

    // gets multiple MapServer services from a single directory
    static directoryService(url: string) {
        var s = new ArcgisServices.ServiceDirectoryModel();
        var d = $.Deferred<Array<Portal.MapLayerLeaf>>();

        s.LoadDirectory(url).then(directory => {
            // service paths contain the parent folder in the name (always?) so 
            // identify this as a folder so it does not get repeated in the uri
            directory.set({ isFolder: !!directory.folders });
            s.fetchMapServices(directory).done(services => {
                var layers = services.map(service => AgsLayers.asLayers(service));

                Utils.when(_.flatten(layers, true)).done(layers => {
                    d.resolve(layers);
                });

            });
        });

        return d;
    }
}

export = AgsDirectory;